import { z } from 'zod';
// oxlint-disable-next-line @typescript-eslint/no-namespace
export var ShippingApiTypes;
(function (ShippingApiTypes) {
    ShippingApiTypes.addressSchema = z.object({
        street1: z.string(),
        street2: z.string().optional(),
        city: z.string(),
        state: z.string().optional(),
        zip: z.string().optional(),
        country: z.string(),
        company: z.string().optional(),
        phone: z.string().optional(),
        name: z.string(),
    });
    ShippingApiTypes.vesylShipmentOptionsSchema = z.object({
        create_and_buy: z.boolean(),
        // omitted when a carrier rejects our requested format, leaving the carrier default
        label_format: z.string().optional(),
        print_custom: z.array(z.object({ value: z.string().nullable() })),
        currency: z.string().optional(),
        // ? Added as an outage prevention option
        label_broker: z.boolean().optional(),
    });
    ShippingApiTypes.easyPostShipmentOptionsSchema = z.object({
        currency: z.string().optional(),
        print_custom_1: z.string().nullable(),
        // omitted when a carrier rejects our requested format, leaving the carrier default
        label_format: z.string().optional(),
    });
    ShippingApiTypes.customsInfoSchema = z.object({
        eel_pfc: z.string(),
        customs_certify: z.boolean(),
        customs_signer: z.string(),
        contents_type: z.string(),
        contents_explanation: z.string(),
        restriction_type: z.string(),
        restriction_comments: z.string(),
        customs_items: z.array(z.object({
            description: z.string(),
            quantity: z.number(),
            weight: z.number(),
            value: z.number(),
            hs_tariff_number: z.string(),
            origin_country: z.string(),
        })),
    });
    const parcelSchema = z.object({
        length: z.number().optional(),
        width: z.number().optional(),
        height: z.number().optional(),
        weight: z.number(),
    });
    ShippingApiTypes.shipmentCreateSchema = z.object({
        from_address: ShippingApiTypes.addressSchema,
        to_address: ShippingApiTypes.addressSchema,
        customs_info: ShippingApiTypes.customsInfoSchema.nullable(),
        parcel: parcelSchema,
        options: z.union([
            ShippingApiTypes.vesylShipmentOptionsSchema,
            ShippingApiTypes.easyPostShipmentOptionsSchema,
        ]),
    });
})(ShippingApiTypes || (ShippingApiTypes = {}));
//# sourceMappingURL=shippingApiTypes.js.map